module.exports = __webpack_public_path__ + "img/icon-component-label_SlicerBar.f9902aac.svg";